import { Player } from '@lottiefiles/react-lottie-player';
import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';
import MerchantSendingApplication from 'lottie/merchant_sending_application.json';

import VerticalStep from './VerticalStep';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  margin-block: 48px;
  max-width: 600px;
  width: 100%;
`;

const Heading = styled(T.Heading2)`
  text-align: center;
  margin-block-start: 48px;
  margin-block-end: 8px;
`;

const Subheading = styled(T.Body3)`
  text-align: center;
  margin-block-end: 48px;
`;

const NextStepsText = styled(T.Body3)`
  margin-block-end: 8px;
  text-align: center;
`;
const StepsWrapper = styled.div`
  max-width: 475px;
  margin-inline: 8px;
`;

const ApplicationSentView = () => {
  const intl = useIntl();
  const t = useCallback((id: string) => intl.formatMessage({ id }), [intl]);

  const steps = [
    {
      number: '1',
      title: t('self-serve-sign-up.application-sent.steps.step-one-title'),
      description: t('self-serve-sign-up.application-sent.steps.step-one-description'),
    },
    {
      number: '2',
      title: t('self-serve-sign-up.application-sent.steps.step-two-title'),
      description: t('self-serve-sign-up.application-sent.steps.step-two-description'),
    },
    {
      number: '3',
      title: t('self-serve-sign-up.application-sent.steps.step-three-title'),
      description: t('self-serve-sign-up.application-sent.steps.step-three-description'),
    },
    {
      number: '4',
      title: t('self-serve-sign-up.application-sent.steps.step-four-title'),
      description: t('self-serve-sign-up.application-sent.steps.step-four-description'),
      borderless: true,
    },
  ];

  return (
    <Wrapper>
      <Player autoplay keepLastFrame src={MerchantSendingApplication} style={{ width: '300px' }}></Player>

      <Heading>
        <FormattedMessage id="self-serve-sign-up.application-sent.header-text" />
      </Heading>

      <Subheading>
        <FormattedMessage id="self-serve-sign-up.application-sent.subheading-text.sent-successfully" />
        <br />
        <FormattedMessage id="self-serve-sign-up.application-sent.subheading-text.thank-you" />
      </Subheading>

      <NextStepsText>
        <FormattedMessage id="self-serve-sign-up.application-sent.next-steps" />:
      </NextStepsText>

      <StepsWrapper>
        {steps.map(step => (
          <VerticalStep {...step} key={step.number} />
        ))}
      </StepsWrapper>
    </Wrapper>
  );
};

export default ApplicationSentView;
